module.exports = __webpack_public_path__ + "img/captain-ship.c727b998.png";